import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableContainer, TableHead, TableRow,
         TableCell, TableBody, Typography, withStyles
} from "@material-ui/core";
import moment from "moment-timezone";
import guid from './../../../../utils/guid';
import NoData from './../../../Common/NoDataRow';
import useStyles from "./tabStyles";
import t from "../../../../languages/pl";
import { displayDateTimeFormat } from './../../../../utils/staticData';

const RefuelTab = props => {
    const { classes, refuels } = props;

    const generateRouteDetailsTable = data => {
        if (!data || data.length === 0)
            return <NoData colSpan={2} />;
        return data.map(row => {
            return (
                <TableRow key={guid()}>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {moment.unix(row.data).format(displayDateTimeFormat)}
                        </Typography>
                    </TableCell>
                    <TableCell className={classes.tableCell}>
                        <Typography variant="body1">
                            {row.litry}&nbsp;l
                        </Typography>
                    </TableCell>
                </TableRow>
            );
        });
    };

    return (
        <TableContainer className={classes.tableContainer}>
            <Table stickyHeader>
                <TableHead>
                    <TableRow >
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.date}
                        </Typography>
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                            <Typography variant="body1">
                                {t.quantity}
                        </Typography>
                        </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {generateRouteDetailsTable(refuels)}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

RefuelTab.propTypes = {
    classes: PropTypes.object,
    refuels: PropTypes.array
};

export default withStyles(useStyles)(RefuelTab);
